export const getPartFieldValue = (partDetails: Record<string, any>[] | undefined, field: string) => {
  return partDetails?.[0]?.[field];
};
